import { FC } from 'react';
import classNames from 'classnames';

import { BaseSymbolData, Week52HighLowResponse } from '../../lib/models/fundamental/types';

import { useBrowserWidth, useIsMobile } from '../../hooks';
import CompanyLogo from '../CompanyLogo/CompanyLogo';
import { getLimitedTextByBrowserWidth } from '../WatchList/WatchList.constans';

import styles from './CompanyInfoBlock.module.scss';

interface CompanyInfoBlockProps {
  item: BaseSymbolData | Week52HighLowResponse,
  itemUrl: string,
  companyName: string | undefined,
  logo?: string,
  oneRowInfoContent?: boolean,
  isWeek52Item?: boolean,
  columnCount?: number,
  isWithNews?: boolean
}

const CompanyInfoBlock: FC<CompanyInfoBlockProps> = ({
  item,
  itemUrl,
  companyName = '',
  logo,
  oneRowInfoContent,
  isWeek52Item,
  columnCount = 5,
  isWithNews,
}) => {
  const { isMobile } = useIsMobile();
  const { browserWidthSize } = useBrowserWidth();

  // Apply dynamic text limiting based on browser width and column count
  const displayName = getLimitedTextByBrowserWidth(browserWidthSize, companyName, isWithNews ?? false, columnCount);

  return (
    <div
      className={classNames(
        styles.companyInfo,
        isMobile && styles.companyInfoMobile,
        isWeek52Item && styles.companyInfoWeek52,
      )}
    >
      <div
        className={styles.companyInfoWrapper}
      >
        <CompanyLogo
          url={itemUrl || ''}
          logo={logo || ''}
          symbol={item.symbol}
        />

        <div className={classNames(styles.companyInfoContent, {
          [styles.companyInfoOneRowContent]: oneRowInfoContent,
        })}
        >
          <span className={styles.companyInfoSymbol}>{item.symbol}</span>

          <span
            className={classNames(styles.companyInfoName)}
          >
            {displayName}
          </span>
        </div>
      </div>
    </div>
  );
};

export default CompanyInfoBlock;
